import { BASE_URL_EG } from '../../../shared/src/config/api';
import axios from 'axios';
// import BotPoisonClient from '@botpoison/browser';

// const botpoisonOptions = {
//   publicKey: 'pk_b871bfd7-ab4d-44ce-91e3-174c2301980c'
// };
// const botpoison = new BotPoisonClient(botpoisonOptions);

const instance = axios.create({
  baseURL: BASE_URL_EG,
  headers: {
    'content-type': 'application/json'
  }
});

// instance.interceptors.request.use(
//   async (config) => {
//     try {
//       const { solution } = await botpoison?.challenge();
//       config.headers['bp'] = solution;
//     } catch (error) {
//       console.error('Error while detecting bot:', error);
//     }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );


export default instance;

export const BaseURl = (): string => {
  return instance.defaults.baseURL || '';
};
